export default {"src":"/login-app/[GIT_HASH]/_next/static/media/password.e33f4157.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};